import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import { Loader } from "@components/atoms";
import { ProductBenefit, ProductTile } from "@components/molecules";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { generateProductUrl } from "../../../../core/utils";
import * as S from "./styles";

function withBenefits(products, benefits) {
  return products.reduce(function (acc, cur, i) {
    benefits.forEach(function (benefit) {
      if (benefit.primary) {
        var _ref = (benefit === null || benefit === void 0 ? void 0 : benefit.primary) || {},
            offset = _ref.offset,
            step = _ref.step;

        var isOffsetI = i === offset;
        var isStepI = i && offset && step && i % (offset + step) === 0;

        if (isStepI || isOffsetI) {
          acc.push(benefit);
        }
      }
    });
    acc.push(cur);
    return acc;
  }, []);
}

export var ProductList = function ProductList(_ref2) {
  var products = _ref2.products,
      _ref2$canLoadMore = _ref2.canLoadMore,
      canLoadMore = _ref2$canLoadMore === void 0 ? false : _ref2$canLoadMore,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      benefits = _ref2.benefits,
      _ref2$innerList = _ref2.innerList,
      innerList = _ref2$innerList === void 0 ? false : _ref2$innerList,
      _ref2$onLoadMore = _ref2.onLoadMore,
      onLoadMore = _ref2$onLoadMore === void 0 ? function () {
    return null;
  } : _ref2$onLoadMore;
  var intl = useIntl();
  return React.createElement(React.Fragment, null, React.createElement(S.List, {
    loading: loading
  }, (benefits ? withBenefits(products, benefits) : products).map(function (item, i) {
    if (item.__typename === "Product") {
      return React.createElement(Link, {
        to: generateProductUrl(item.id, item.name),
        key: item.id
      }, React.createElement(ProductTile, {
        product: item
      }));
    }

    return React.createElement(ProductBenefit, _extends({
      key: i
    }, item));
  })), !innerList && React.createElement(React.Fragment, null, React.createElement(S.BorderDiv, null), React.createElement(S.Loader, null, loading ? React.createElement(Loader, null) : canLoadMore && React.createElement(S.List, {
    loading: loading
  }, React.createElement(S.ShowMoreButton, {
    className: "red",
    "data-cy": "load-more_button",
    onClick: onLoadMore
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "show more",
    "id": "@next.components.organisms.ProductList.ProductList.702815459"
  }, "id", "@next.components.organisms.ProductList.ProductList.702815459")))))));
};
ProductList.displayName = "ProductList";